var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

import { get } from './utils';

// endpoint request
export var getLeaderboard = function getLeaderboard(tournamentId) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  return get('/casinotournament/leaderboard?TournamentIdentifier=' + tournamentId + '&Offset=' + offset + '&Limit=' + limit);
};

export var getRelativeLeaderboard = function getRelativeLeaderboard(tournamentId, playerId) {
  var playersBeforeAndAfter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return get('/casinotournament/leaderboard-relative?tournamentIdentifier=' + tournamentId + '&playerId=' + playerId + '&playersBeforeAndAfter=' + playersBeforeAndAfter);
};

export var getCasinoTournament = function getCasinoTournament(gameId) {
  return get('/casinotournament?GameId=' + gameId);
};

export var getFullLeaderboard = function getFullLeaderboard(tournamentId) {
  return new Promise(function (resolve, reject) {
    var fetch = function fetch(limit, offset, fullList) {
      getLeaderboard(tournamentId, offset, limit).then(function (_ref) {
        var res = _ref.data;

        if (!res || !res.Players) return reject({});

        // Due to an bug(?) in aleacc the position needs to be combined with the offset to get the correct sort order.
        var players = res.Players.map(function (item) {
          return _extends({}, item, {
            Position: item.Position + offset
          });
        });

        // Concat the old player list with the recently fetched.
        fullList = [].concat(_toConsumableArray(fullList), _toConsumableArray(players));

        // If the number of items in the list matches the limit, fetch the next page.
        if (players.length === limit) return fetch(limit, offset + limit, fullList);

        var data = _extends({}, res, {
          Players: fullList
        });

        resolve({
          data: data
        });
      }).catch(function (e) {
        return reject(e);
      });
    };

    fetch(100, 0, []);
  });
};

export default {
  getLeaderboard: getLeaderboard,
  getRelativeLeaderboard: getRelativeLeaderboard,
  getFullLeaderboard: getFullLeaderboard,
  getCasinoTournament: getCasinoTournament
};